import { render, staticRenderFns } from "./CustomerIntegrationDetail.vue?vue&type=template&id=07ede879"
import script from "./CustomerIntegrationDetail.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports